import {createReducer} from 'utils/redux';
import {SET_USER_PAYMENTS} from 'actions/user';

const initialState = [];

export default createReducer(initialState, {
  [SET_USER_PAYMENTS]: (state, {payload: payments}) => ({...state, payments}),
});
